// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgPin16 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.4821 3C11.4821 2.44772 11.0343 2 10.4821 2H5.48206C4.92978 2 4.48206 2.44772 4.48206 3L4.482 7.983L3.09999 10.0684C3.03478 10.1667 3 10.282 3 10.4C3 10.7314 3.26863 11 3.6 11H7.4V14.5C7.4 14.8314 7.66863 15.1 8 15.1C8.33137 15.1 8.6 14.8314 8.6 14.5V11H12.3667C12.698 11 12.9667 10.7314 12.9667 10.4L12.9603 10.3125C12.9475 10.226 12.9159 10.1429 12.8673 10.0693L11.482 7.972L11.4821 3ZM5.682 3.2H10.282L10.282 8.33253L11.251 9.8H4.717L5.682 8.34455L5.682 3.2Z"
			/>
		</Svg>
	);
});
SvgPin16.defaultProps = {
	size: 16,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgPin16;
